import { render, staticRenderFns } from "./GoogleConnect.vue?vue&type=template&id=23b8b4bc&scoped=true"
import script from "./GoogleConnect.vue?vue&type=script&lang=js"
export * from "./GoogleConnect.vue?vue&type=script&lang=js"
import style0 from "./GoogleConnect.vue?vue&type=style&index=0&id=23b8b4bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b8b4bc",
  null
  
)

export default component.exports